import { createRouter, createWebHistory } from "vue-router";
import HomeComponent from "@/views/HomeView";
import EditEventComponent from "@/components/event/EventEdit";
import CreateEventComponent from "@/components/event/EventCreate";
import EventComponent from "@/components/event/EventDetail";
import HistoryComponent from "@/views/HistoryView";
import MonthComponent from "@/components/month/MonthDetail";
import FixedMonthCreateGoalComponent from "@/components/goal/FixedMonthGoalCreate";
import AuthLogin from "@/components/auth/AuthLogin.vue";
import AuthRegister from "@/components/auth/AuthRegister.vue";
import ProfileView from "@/components/profile/ProfileView";
import GraphView from "../components/graph/GraphView.vue";
import EditGoalComponent from "../components/goal/GoalEdit.vue";
import ErrorComponent from "@/components/error/ErrorView.vue";
import ImprintComponent from "@/components/legal/ImprintComponent.vue";
import PrivacyPolicyComponent from "@/components/legal/PrivacyPolicyComponent.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: { name: "home" } },
    { path: "/home", name: "home", component: HomeComponent },
    { path: "/event", name: "createevent", component: CreateEventComponent },
    {
      path: "/event/edit/:id",
      name: "editevent",
      component: EditEventComponent,
    },
    { path: "/event/:id", name: "event", component: EventComponent },
    { path: "/history", name: "history", component: HistoryComponent },
    { path: "/month/:month", name: "month", component: MonthComponent },
    {
      path: "/goal/:month",
      name: "creategoal",
      component: FixedMonthCreateGoalComponent,
    },
    {
      path: "/goal/edit/:month",
      name: "editgoal",
      component: EditGoalComponent,
    },
    { path: "/login", name: "login", component: AuthLogin },
    { path: "/register", name: "register", component: AuthRegister },
    { path: "/profile", name: "profile", component: ProfileView },
    { path: "/graph", name: "graph", component: GraphView },
    { path: "/error", name: "error", component: ErrorComponent },
    { path: "/imprint", name: "imprint", component: ImprintComponent },
    {
      path: "/privacy-policy",
      name: "privacypolicy",
      component: PrivacyPolicyComponent,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const publicRoutes = ["login", "register", "imprint", "privacypolicy"];
  const token = localStorage.getItem("jwt");
  if (!publicRoutes.includes(to.name) && !token) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
